export interface Group {
  prefix: string
  label: string
  hue: number
  c: number
}

export const DEFAULT_GROUPS: Group[] = [
  { prefix: 'A', label: 'Arbete',              hue: 220, c: 0.10 },
  { prefix: 'U', label: 'Underentreprenör (UE)', hue: 160, c: 0.11 },
  { prefix: 'M', label: 'Maskin & utrustning', hue: 75,  c: 0.13 },
  { prefix: 'E', label: 'El-installation',     hue: 295, c: 0.12 },
  { prefix: 'V', label: 'VVS',                 hue: 195, c: 0.10 },
  { prefix: 'P', label: 'Påslag',              hue: 50,  c: 0.12 },
]

// Standard groups required on every project (customer feedback 2026-06, WI #12353):
// "Arbete" and "Underentreprenör (UE)" must always exist and not be removable by mistake.
export const STANDARD_GROUPS: Group[] = [
  DEFAULT_GROUPS[0], // Arbete
  DEFAULT_GROUPS[1], // Underentreprenör (UE)
]

export const isStandardGroup = (prefix: string): boolean =>
  STANDARD_GROUPS.some(g => g.prefix === prefix)

// Ensures the standard groups are always present, restoring any that are missing
// (e.g. projects saved before UE existed, or one removed directly in stored JSON).
export const withStandardGroups = (groups: Group[]): Group[] => {
  const missing = STANDARD_GROUPS.filter(s => !groups.some(g => g.prefix === s.prefix))
  return [...missing, ...groups]
}
